$.fn.projectHover = function() {
  let self = this

  if (self.data('project-hover')) {
    return self.data('project-hover')
  }

  self.rollover_image = $(this).find("picture").data("rollover");
  self.is_loaded = false;
  self.is_hovering = false;
  self.timeouts = [];
  self.events = {
    in : "mouseenter",
    out : "mouseleave"
  };

  // create rollover
  if (self.rollover_image) {
    let spritesheet_url = "/frames/" + colossale_l10n.version + "/" + self.rollover_image,
    spritesheet_width = parseInt(self.find('.picture').attr('data-width'), 10)
    self.coordinates = $(this).find("picture").data("coordinates");
    if ($('html').hasClass('has-webp') && $(this).find("picture").data("webp") == 'yes') {
      spritesheet_url += '.webp'
    }
    self.find("picture").append('<div class="rollover-holder"></div>');
    var loader_image = $('<img>').on("load", function() {
      self.is_loaded = true;
      if (self.is_hovering == true) {
        self.trigger(self.events.in);
      }
    }).addClass("loader_image").attr("src", spritesheet_url);
    $("body").append(loader_image);
    self.on(self.events.in, function() {
      if (self.is_loaded === true) {
        var ratio = self.find("picture").width() / spritesheet_width,
        duration = 125,
        paddingTop = parseInt(self.find("picture").css('padding-top')) / parseInt(self.find("picture").width()),
        bleed = 0
        self.find(".rollover-holder").addClass("sprite-visible").css({
          "top" : "-" + (bleed*paddingTop) + "px", "left" : "-" + bleed + "px",
          "width" : self.find("picture").width() + (bleed*2) + "px",
          "height" : Math.floor(self.find("picture").width() * paddingTop + (bleed*2) * paddingTop) + "px",
          "background-image" : 'url(' + spritesheet_url + ')',
          "background-size" : self.find("picture").width() + (bleed*2) + "px auto",
          "background-position" : "0px 0px"
        });
        for (var i = 1; i < self.coordinates.length; i++) {
          var frame = function(i) {
            var timeout = setTimeout(function() {
              self.find(".rollover-holder").css({
                "background-position" : "0px " + (-self.coordinates[i] * ratio) + "px"
              });
            }, i * duration);
            self.timeouts.push(timeout);
          }(i);
        }
      }
      self.is_hovering = true;
    }).on(self.events.out, function() {
      self.is_hovering = false;
      self.find(".rollover-holder").removeClass("sprite-visible").css({
        "background-size" : "",
        "background-position" : ""
      });
      self.timeouts.forEach(function(x) {
        clearTimeout(x);
      }); self.timeouts = [];
    });
  }

  return function() {
    self.data('project-hover', self)
    return self
  }()
}
